import hs_do from "./hs_do";
import hs_re from "./hs_re";
import hs_mi from "./hs_mi";
import hs_fa from "./hs_fa";
import hs_so from "./hs_so";
import hs_la from "./hs_la";
import hs_ti from "./hs_ti";

import hs_di from "./hs_di";
import hs_ri from "./hs_ri";
import hs_fi from "./hs_fi";
import hs_si from "./hs_si";
import hs_li from "./hs_li";

import hs_ra from "./hs_ra";
import hs_ma from "./hs_ma";
import hs_sa from "./hs_sa";
import hs_lo from "./hs_lo";
import hs_ta from "./hs_ta";

export default [
    {
        // fa
        "0": hs_fa,
        "1": hs_fi,
    },
    {
        // do
        "0": hs_do,
        "1": hs_di,
    },
    {
        // so
        "-1": hs_sa,
        "0": hs_so,
        "1": hs_si,
    },
    {
        // re
        "-1": hs_ra,
        "0": hs_re,
        "1": hs_ri,
    },
    {
        // la
        "-1": hs_lo,
        "0": hs_la,
        "1": hs_li,
    },
    {
        // mi
        "-1": hs_ma,
        "0": hs_mi,
    },
    {
        // ti
        "-1": hs_ta,
        "0": hs_ti,
    },
];
